"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WrappedPropertyBase_1 = require("./WrappedPropertyBase");
var fmoney_1 = require("../methods/fmoney");
var mround_1 = require("../methods/mround");
var fnumber_1 = require("../methods/fnumber");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var functions_1 = require("./functions");
var WrappedPropertyNumber = /** @class */ (function (_super) {
    __extends(WrappedPropertyNumber, _super);
    function WrappedPropertyNumber(dest, parent, propName, schema, options) {
        var _this = _super.call(this, dest, parent, propName, schema, options) || this;
        // //export const wrapSchemaProps = ['maxLength', 'minLength', 'maxItems', 'minItems', 'minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum', 'precision'];
        functions_1.wrapSchemaProps(_this.$schema, _this._internal, 'number', ['minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum', 'precision']);
        _this._internal.typeok = true;
        functions_1.initVue(_this, _this._internal);
        return _this;
    }
    WrappedPropertyNumber.prototype.$validate = function (value) {
        if (value === undefined) {
            value = this.$model;
        }
        // console.time('(number)$validate');
        this.$dirty = true;
        if (value === null) {
            // console.timeEnd('(number)$validate');
            if (!this._internal.typeok) {
                return functions_1.getRuleMessage(this._internal, 'type', value, this.$schema);
            }
            if (this.$schema.fieldRequired) {
                return functions_1.getRuleMessage(this._internal, 'required', value, this.$schema);
            }
            if (this.$schema.enum) {
                if (this.$schema.enum.indexOf(value) === -1) {
                    return functions_1.getRuleMessage(this._internal, 'enum', value, this.$schema);
                }
            }
            return null;
        }
        var ivalue = +value;
        // console.timeEnd('(number)$validate');
        return _super.prototype.$validate.call(this, ivalue);
    };
    Object.defineProperty(WrappedPropertyNumber.prototype, "$stringValue", {
        get: function () {
            return this.$getUserData('stringValue', null);
        },
        enumerable: true,
        configurable: true
    });
    WrappedPropertyNumber.prototype.getValue = function () {
        var ivalue = this.$model;
        // let ivalue = obj.$model;
        /*
        if (this.$dirty) {
          this.$validate(ivalue);
        }
        */
        var stringValue = this.$getUserData('stringValue', null);
        if (ivalue === null) {
            // const svalue = this._internal.vm.stringValue;
            // if (svalue !== undefined && svalue !== null) {
            if (stringValue !== null) {
                return stringValue;
            }
            else {
                return '';
            }
        }
        if (isNaN(+ivalue)) {
            ivalue = 0;
        }
        // const err = validate(obj, ivalue);
        // if (obj.$path === 'LiczbaOdbiorcowZadania') {
        //  console.log('validate ', JSON.stringify(ivalue), JSON.stringify(err));
        // }
        // vm.error = err ? getRuleMessage(schema, err, ivalue, $schema) : null;
        // let svalue = (""+self.mround(ivalue)).replace(".",",");
        var svalue = '';
        switch (this.$schema.type) {
            case 'number':
                if (this.$schema.precision === undefined) {
                    svalue = fnumber_1.default(ivalue, 8);
                }
                else {
                    svalue = fnumber_1.default(ivalue, this.$schema.precision);
                }
                svalue = fnumber_1.default(ivalue, this.$schema.precision || 8);
                break;
            case 'money':
                if (this.$schema.precision === undefined) {
                    svalue = fmoney_1.default(ivalue, false, 2);
                }
                else {
                    svalue = fmoney_1.default(ivalue, false, this.$schema.precision);
                }
                break;
            case 'integer':
                svalue = fnumber_1.default(ivalue, 0);
                break;
        }
        // console.log($schema.type + 'Computed(get)', propName, JSON.stringify(svalue), err);
        return svalue;
    };
    WrappedPropertyNumber.prototype.setValue = function (newValue) {
        this._internal.typeok = true;
        var ivalue = null;
        if (this._options.dirtyOnInput) {
            this.$dirty = true;
        }
        // console.log('set model', JSON.stringify(newValue));
        if (newValue === '' || newValue == null) {
            /*
            if (this.$dirty && this.$schema.fieldRequired) {
              this.$error = getRuleMessage(this._internal.schema, 'required', newValue, this.$schema);
              // ok = false;
              // typeok = false;
            }
            */
            /*
                                      if (schema.default !== undefined) {
                                          ivalue = schema.default;
                                          //if (ivalue===0) {
                                          //    typeok=true;
                                          //}
                                      }
                                      */
            ivalue = null;
            // this.$setUserData('stringValue', null);
        }
        else {
            ivalue = +newValue.replace(',', '.');
            if (isNaN(ivalue)) {
                /*
                if (this.$dirty) {
                  this.$error = getRuleMessage(this._internal.schema, 'type', newValue, this.$schema);
                }
                this._internal.typeok = false;
                */
                this._internal.typeok = false;
                // this.$setUserData('stringValue', newValue);
                // this.stringValue = newValue;
                // ivalue = schema.default || null;
                ivalue = null;
            }
            else {
                // this.$setUserData('stringValue', null);
            }
        }
        // savedValue = ivalue;
        // if (this.focused) {
        if (!this._internal.typeok) {
            // tslint:disable-next-line: no-console
            // console.log('set $stringValue', newValue);
            this.$setUserData('stringValue', newValue);
            // this._internal.vm.stringValue = newValue;
        }
        else {
            this.$setUserData('stringValue', null);
            // this._internal.vm.stringValue = null;
        }
        var dvalue = 0;
        if (ivalue === null) {
            this.$model = null;
        }
        else {
            switch (this.$schema.type) {
                case 'integer':
                    // console.log('set model', obj.$path, JSON.stringify(ivalue), JSON.stringify(mround(ivalue, 0)));
                    dvalue = mround_1.default(ivalue, 0);
                    break;
                case 'money':
                    if (this.$schema.precision === undefined) {
                        dvalue = mround_1.default(ivalue, 2);
                    }
                    else {
                        dvalue = mround_1.default(ivalue, this.$schema.precision);
                    }
                    break;
                case 'number':
                    if (this.$schema.precision === undefined) {
                        dvalue = mround_1.default(ivalue, 8);
                    }
                    else {
                        dvalue = mround_1.default(ivalue, this.$schema.precision);
                    }
                    break;
            }
            // console.log(schema.type + 'Computed(set)', propName, JSON.stringify(dvalue), JSON.stringify(typeok));
            // parent[propName] = dvalue;
            this.$model = dvalue;
        }
    };
    return WrappedPropertyNumber;
}(WrappedPropertyBase_1.default));
exports.default = WrappedPropertyNumber;
WrappedPropertyCtor_1.default.integer = WrappedPropertyNumber;
WrappedPropertyCtor_1.default.number = WrappedPropertyNumber;
WrappedPropertyCtor_1.default.money = WrappedPropertyNumber;
//# sourceMappingURL=WrappedPropertyNumber.js.map